


    <p-scrollPanel [style]="{height: '100vh'}">
      <p-card class="mb-8">

        <ng-template pTemplate="header">
          <div class="flex items-center justify-between">
            <div class="p-card-title">Promo Codes</div>
            <div>
              <p-button type="button" icon="pi pi-plus" label="Add Promo Code" (click)="openAddPromoForm()" />
              <p-dialog [(visible)]="showForm" [modal]="true" [closable]="true"
                [style]="{width: '90vw', maxWidth: '600px'}">
                <app-promo-form (formSubmitted)="promoFormSubmitted($event)"></app-promo-form>
              </p-dialog>
            </div>
          </div>  

        </ng-template>


        <p-table #dt2 [value]="promoCodes()" dataKey="id" class="w-full responsive-table"
          styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '50rem'}"
          [globalFilterFields]="['name', 'description', 'requiredTeamSize', 'promoStart', 'promoEnd']"
          [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 20, 50]">

          <ng-template pTemplate="caption">

            <div class="flex">
              <p-iconfield iconPosition="left" class="ml-auto">
                <p-inputicon>
                  <fa-icon [icon]="icons.solid.faMagnifyingGlass" />
                </p-inputicon>
                <input pInputText type="text" (input)="filterTableGlobal($event)" placeholder="Search keyword" />
              </p-iconfield>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="name" pFrozenColumn>
                <div class="flex items-center">Name <p-sortIcon field="name" /></div>
              </th>
              <th pSortableColumn="description">
                <div class="flex items-center">Description <p-sortIcon field="description" /></div>
              </th>
              <th pSortableColumn="requiredTeamSize">
                <div class="flex items-center">Required Team Size <p-sortIcon field="requiredTeamSize" /></div>
              </th>

              <th pSortableColumn="promoStart">
                <div class="flex items-center">Promo Start <p-sortIcon field="promoStart" /> </div>
              </th>
              <th pSortableColumn="promoEnd">
                <div class="flex items-center">Promo End <p-sortIcon field="promoEnd" /></div>
              </th>
              <th pSortableColumn="tripStart">
                <div class="flex items-center">Trip Start <p-sortIcon field="tripStart" /></div>
              </th>

              <th pSortableColumn="tripEnd">
                <div class="flex items-center">Trip End <p-sortIcon field="tripEnd" /></div>
              </th>
              <th pSortableColumn="isPercentage" class="header-group">
                <div class="flex items-center">% Discount <p-sortIcon field="isPercentage" /></div>
              </th>
              <th pSortableColumn="percentage" class="header-group">
                <div class="flex items-center">Percentage <p-sortIcon field="percentage" /> </div>
              </th>
              <th pSortableColumn="discountAmount" class="header-group">
                <div class="flex items-center">Flat Discount Amount <p-sortIcon field="discountAmount" /></div>
              </th>

              <th pSortableColumn="tripCostDiscounted" class="header-group">
                <div class="flex items-center">Trip Cost Discount <p-sortIcon field="tripCostDiscounted" /> </div>
              </th>
              <th pSortableColumn="numberTripsDiscounted" class="header-group">
                <div class="flex items-center"># Trips Discounted <p-sortIcon field="numberTripsDiscounted" />
                </div>
              </th>
              <th pSortableColumn="perPerson">
                <div class="flex items-center">Per Person <p-sortIcon field="perPerson" /></div>

              </th>
              <th pSortableColumn="perPersonCount">
                <div class="flex items-center">Per Person Count <p-sortIcon field="perPersonCount" /></div>
              </th>

              <th>Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-promo>
            <tr>
              <td pFrozenColumn>
                {{ promo.name }}
              </td>
              <td>
                <div [pTooltip]="promo.description">{{ promo.description | truncate:truncateCount }}</div>
              </td>
              <td style="text-align: right;">
                {{ promo.requiredTeamSize }}
              </td>
              <td style="text-align: right;" class="bg-shade">
                {{ promo.promoStart | date: 'MM/dd/yyyy' }}
              </td>
              <td style="text-align: right;" class="bg-shade">
                {{ promo.promoEnd | date: 'MM/dd/yyyy' }}
              </td>
              <td style="text-align: right;">
                {{ promo.tripStart | date: 'MM/dd/yyyy' }}
              </td>
              <td style="text-align: right;">
                {{ promo.tripEnd | date: 'MM/dd/yyyy' }}
              </td>
              <td class="bg-shade">
                <div class="flex justify-center">{{ promo.isPercentage | yesNo | titlecase }}</div>
              </td>
              <td style="text-align: right;" class="bg-shade">
                {{ promo.percentage }}
              </td>
              <td style="text-align: right;">
                {{ promo.discountAmount }}
              </td>
              <td class="bg-shade">
                <div class="flex justify-center"> {{ promo.tripCostDiscounted | yesNo | titlecase }}</div>
              </td>
              <td style="text-align: right;" class="bg-shade">
                {{ promo.numberTripsDiscounted }}
              </td>
              <td>
                <div class="flex justify-center">{{ promo.perPerson | yesNo | titlecase }}</div>
              </td>
              <td style="text-align: right;">
                {{ promo.perPersonCount }}
              </td>
              <td>
                <div class="flex items-center justify-center gap-2">
                  <button pButton pRipple type="button" icon="pi pi-pencil" (click)="editPromo(promo)" class="p-button-rounded p-button-text"></button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>


      </p-card>
    </p-scrollPanel>
   